import React from 'react';
import styled from 'styled-components';
import { COLORS, BREAKPOINT_SIZE } from '../theme';
const ArrowsContainer = styled.div<{ isRotated?: boolean }>`
  display: flex;
  align-self: center;
  margin: 10px;

  @media (max-width: ${BREAKPOINT_SIZE.md}px) {
    transform: rotate(90deg);
  }
`;

const Arrow = styled.div<{ isDown?: boolean }>`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 10px;
  border-width: 2px 2px 0 0;
  border-style: solid;
  margin: 4px;
  box-sizing: border-box;
  transform: ${props => (props.isDown ? 'rotate(135deg)' : 'rotate(-45deg)')};
  margin-top: ${props => (props.isDown ? '11px' : '4px')};
  color: ${COLORS.blue};

  :after,
  :before {
    content: '';
    box-sizing: border-box;
  }
  :before {
    right: 0;
    top: -1px;
    position: absolute;
    height: 2px;
    box-shadow: inset 0 0 0 32px;
    transform: rotate(-45deg);
    width: 16px;
    transform-origin: right top;
  }
`;

const Arrows = () => (
  <ArrowsContainer>
    <Arrow />
    <Arrow isDown />
  </ArrowsContainer>
);

export default Arrows;
